"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timestamp = void 0;
class Timestamp {
    constructor(value) {
        if (typeof value === "number") {
            this.milliseconds = value;
        }
        else if (value instanceof Date) {
            this.milliseconds = value.valueOf();
        }
        else {
            this.milliseconds = Date.now();
        }
    }
    toDate() {
        return new Date(this.milliseconds);
    }
    toMilliseconds() {
        return this.milliseconds;
    }
    toSeconds() {
        return this.milliseconds / 1000;
    }
    toMinutes() {
        return this.milliseconds / 1000 / 60;
    }
    addMilliseconds(milliseconds) {
        return new Timestamp(this.milliseconds + milliseconds);
    }
    addSeconds(seconds) {
        return new Timestamp(this.milliseconds + seconds * 1000);
    }
    addMinutes(minutes) {
        return new Timestamp(this.milliseconds + minutes * 60 * 1000);
    }
    addHours(hours) {
        return new Timestamp(this.milliseconds + hours * 60 * 60 * 1000);
    }
    addDays(days) {
        return new Timestamp(this.milliseconds + days * 24 * 60 * 60 * 1000);
    }
    isBefore(other) {
        return this.milliseconds < other.milliseconds;
    }
    isAfter(other) {
        return this.milliseconds > other.milliseconds;
    }
}
exports.Timestamp = Timestamp;
Timestamp.zero = () => new Timestamp(0);
